<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="createOrgDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Create Organization</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="createOrgForm"
    (ngSubmit)="create()"
  >
    <input
      autocomplete="off"
      #orgName
      spellcheck="false"
      data-cy="createOrgDialogOrgNameInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          createOrgForm.controls['orgName'].invalid &&
          createOrgForm.controls['orgName'].touched
      }"
      formControlName="orgName"
      placeholder="Organization Name"
    />
    <m-validation [control]="createOrgForm.controls['orgName']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="createOrgDialogCreateButton"
        class="bg-m600 text-m0 w-28 rounded py-3 font-medium focus:outline-none"
        type="submit"
        >Create</button
      >

      <button
        data-cy="createOrgDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
